export const userRoles = {
    SuperAdmin: 'superAdmin',
    Admin: 'admin',
    User: 'user',
    Enterprise: 'enterprise',
    SharedUser: 'sharedUser',
    EnterpriseNoApi: 'enterpriseNoApi',
};
